"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClientSubscriptionStatus = useClientSubscriptionStatus;
var client_1 = require("../api/client");
var constants_1 = require("../constants/constants");
// a hook rather than a selector so reading the plan also subscribes to it: nothing else fetches the subscription
function useClientSubscriptionStatus() {
    var clientSubscription = (0, client_1.useGetClientSubscriptionQuery)().data;
    var _a = clientSubscription !== null && clientSubscription !== void 0 ? clientSubscription : {}, name = _a.name, status = _a.status;
    var isActive = status === "ACTIVE";
    return {
        isUnsubscribed: !name,
        isFreemiumPlan: isActive && name === constants_1.SubscriptionPlans.FREEMIUM,
        isBusinessPlan: isActive && name === constants_1.SubscriptionPlans.BUSINESS,
        isGrowthPlan: isActive && name === constants_1.SubscriptionPlans.GROWTH,
        isStarterPlan: isActive && name === constants_1.SubscriptionPlans.STARTER,
    };
}
